import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as WarningBlue } from 'assets/icons/warning-blue.svg';
import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { Modal, TextAreaField, Label } from 'components';
import { isInvestor,  outcomes,isRejectedStatus, isSubmitter, isObjectionCommittee } from 'utils';
import { radioOptions } from './utils';
import { updateFormField } from 'store/forms/actions';
import { Radio } from 'antd';
import isEmpty from 'lodash/isEmpty';
import { isBeneficiary, isAuditor } from 'utils';

const SubmitModal = ({
  isVisible,
  setIsVisible,
  handleSubmit,
  submitDisabled,
  formKey,
  outcome,
  businessKey,
}) => {
  const dispatch = useDispatch();
  const rejectKtpReason = useSelector(state => state.forms?.carrier?.rejectKtpReason);
  const rejectKtpMessage = useSelector(state => state.forms?.carrier?.rejectKtpMessage);
  const returnAuditorMessage = useSelector(state => state.forms?.audit?.returnAuditorMessage);
  const user = useSelector(state => state.user);
  const isUserKTP = ( user?.groups?.filter(a => a.id.startsWith("KTP")).length >0 );
  const isUserProvider = ( user?.groups?.filter(a => a.id.startsWith("ProviderResourceGroup")).length >0 );
  const taskName = useSelector(state => state.forms.task.taskName);
  const rejectImplementer = outcome === outcomes.rejectImplementer;
  const returnAuditor = outcome === outcomes.returnAuditor;
  const cancelBeneficiary = outcome === outcomes.cancelBeneficiary;
  const auditApprove = outcome === outcomes.auditApprove;
  const auditReject = outcome === outcomes.auditReject;
  const objectionCommitteeReject = outcome === outcomes.objectionCommitteeReject;

  const renderContent = () => {
    if (isBeneficiary(user?.groups)) {
      if ( (taskName === "task.name.application_submission" || taskName === "task.name.application_returned_to_beneficiary") && !cancelBeneficiary ){
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Υποβολή Αίτησης
          </div>Πρόκειται να υποβάλετε αίτηση χρηματοδότησης σε μορφή voucher στο πρόγραμμα «ΑΛΛΑΖΩ ΣΥΣΤΗΜΑ ΘΕΡΜΑΝΣΗΣ ΚΑΙ ΘΕΡΜΟΣΙΦΩΝΑ». Παρακαλούμε επιβεβαιώστε την ενέργεια διαφορετικά επιλέξτε Ακύρωση. 
          </div>
        )
      }
      else if ( (taskName === "task.name.temporary_rejected")){
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Υποβολή Αίτησης
          </div>Πρόκειται να υποβάλετε αίτημα επανεξέτασης. Η ενέργεια είναι μη αναστρέψιμη. Επιλέξτε το "Επιβεβαίωση" αν επιθυμείτε να συνεχίσετε διαφορετικά επιλέξτε "Ακύρωση".</div>
        )
      }  
      else if (taskName === "task.name.application_submission" && !cancelBeneficiary ) {
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Ακύρωση Αίτησης
          </div>Με την ενέργεια αυτή πρόκειται να ακυρώσεται την αίτηση σας. Η ενέργεια αυτή είναι μή αναστρέψιμη. Παρακαλούμε επιβεβαιώστε την ενέργεια διαφορετικά επιλέξτε Ακύρωση. 
          </div>
        )
      } else {
        return (
          <div>
            <div className="content-title color-blue-3 font-size-24 mb-2">
            Ακύρωση Αίτησης 2
          </div>Με την ενέργεια αυτή πρόκειται να ακυρώσεται την αίτηση σας. Η ενέργεια αυτή είναι μή αναστρέψιμη. Παρακαλούμε επιβεβαιώστε την ενέργεια διαφορετικά επιλέξτε Ακύρωση. 
          </div>
        )
      }
    } else if(isUserKTP){
      return (
        <div>
          <br/>
          <div className="content-title color-blue-3 font-size-24">
            {rejectImplementer
              ? 'Απόρριψη Αίτησης'
              : 'Έγκριση Αίτησης'}
          </div>
          <br/>
          <div className="content-paragraph">
            {rejectImplementer ? (
              <div>
                <div className="mb-2">
                  Για να οριστικοποιήσετε την Απόρριψη της Αίτησης, παρακαλούμε επιλέξτε την Αιτιολογία Απόρριψης και πατήστε “Επιβεβαίωση”. 
                  Διαφορετικά, μπορείτε να επιλέξετε “Επιστροφή”. Η ενέργεια είναι μη αναστρέψιμη.
                </div>
                <Label
                  label={'Αιτιολογία Απόρριψης'}
                  asterisk={true}
                  customClass={'text-bold'}
                />
                <Radio.Group
                  className={'reject-modal-radio-options'}
                  options={radioOptions}
                  value={rejectKtpReason}
                  size="small"
                  onChange={event =>{
                    dispatch(
                      updateFormField({
                        group: 'carrier',
                        key: 'rejectKtpReason',
                        value: event.target.value,
                      })
                    )
                  }
                  }
                />
                {
                  rejectKtpReason?.includes('Άλλος Λόγος') &&
                  <div className="mt-2">
                  <TextAreaField
                    label={'Μήνυμα Απόρριψης'}
                    placeholder={'Προσθήκη Σχολίου'}
                    asterisk={true}
                    name={'rejectKtpMessage'}
                    value={rejectKtpMessage}
                    maxLength={500}
                    onChange={event =>
                      dispatch(
                        updateFormField({
                          group: 'carrier',
                          key: event.target.name,
                          value: event.target.value,
                        })
                      )
                    }
                  />
                </div>
              }
              </div>
            ) : (
              'Για να οριστικοποιήσετε την Έγκριση της αίτησης, παρακαλούμε πατήστε το κουμπί "Επιβεβαίωση". Διαφορετικά, μπορείτε να επιλέξετε "Επιστροφή". Η ενέργεια είναι μη αναστρέψιμη.'
            )
          }
          </div>
        </div>
      );
    } else if(isAuditor(user?.groups)){
      return (
        <div>
          <br/>
          <div className="content-title color-blue-3 font-size-24">
            {returnAuditor ?
              'Επιστροφή στον Ωφελούμενο'
              :
                auditReject
              ? 'Απόρριψη Αίτησης'
              : 'Έγκριση Αίτησης'}
          </div>
          <br/>
          <div className="">
              { returnAuditor ?
                  <>
                      <div className="mb-2">
                      Πρόκειται να επιστρέψετε την αίτηση <b>{businessKey}</b> στον Ωφελούμενο. 
                      Παρακαλούμε εισάγετε τα σχόλιά σας. 
                      </div>
                      <div className="mt-2">
                        <TextAreaField
                          label={'Σχόλιο'}
                          placeholder={'Προσθήκη Σχολίου'}
                          asterisk={true}
                          name={'returnAuditorMessage'}
                          value={returnAuditorMessage}
                          maxLength={1000}
                          onChange={event =>
                            dispatch(
                              updateFormField({
                                group: 'audit',
                                key: event.target.name,
                                value: event.target.value,
                              })
                            )
                          }
                        />
                      </div>
                  </>
                : auditReject ?
                  <div className="">
                    Πρόκειται να υποβάλετε την αξιολόγησή σας για την αίτηση <b>{businessKey}</b>. Η ενέργεια είναι μη αναστρέψιμη. Επιλέξτε το "Επιβεβαίωση" αν επιθυμείτε να συνεχίσετε διαφορετικά επιλέξτε "Ακύρωση".
                  </div>
                :  
                  <div className="">
                  Πρόκειται να υποβάλετε την αξιολόγησή σας για την αίτηση <b>{businessKey}</b>. Η ενέργεια είναι μη αναστρέψιμη. Επιλέξτε το "Επιβεβαίωση" αν επιθυμείτε να συνεχίσετε διαφορετικά επιλέξτε "Ακύρωση".
                  </div>
              }
          </div>
        </div>
      );
    } else if(isObjectionCommittee(user?.groups)){
      return (
        <div>
          <br/>
          <div className="content-title color-blue-3 font-size-24">
            { objectionCommitteeReject
              ? 'Απόρριψη Ένστασης'
              : 'Έγκριση Ένστασης'}
          </div>
          <br/>
          <div className="">
              { objectionCommitteeReject ?
                  <div className="">
                    Πρόκειται να υποβάλετε την αξιολόγησή σας στο αίτημα επανεξέτασης για την αίτηση <b>{businessKey}</b>. Η ενέργεια είναι μη αναστρέψιμη. Επιλέξτε το "Επιβεβαίωση" αν επιθυμείτε να συνεχίσετε διαφορετικά επιλέξτε "Ακύρωση".
                  </div>
                :  
                  <div className="">
                    Πρόκειται να υποβάλετε την αξιολόγησή σας στο αίτημα επανεξέτασης για την αίτηση <b>{businessKey}</b>. Η ενέργεια είναι μη αναστρέψιμη. Επιλέξτε το "Επιβεβαίωση" αν επιθυμείτε να συνεχίσετε διαφορετικά επιλέξτε "Ακύρωση".
                  </div>
              }
          </div>
        </div>
      );
    }
  };

  const submit = (() => {
    setIsVisible(false);
    handleSubmit();
  })

  return (
    <>
    <Modal
      isVisible={isVisible}
      handleCancel={() => {
        setIsVisible(false)
        if (outcome === outcomes.rejectImplementer) {
          dispatch(
            updateFormField({
              group: 'carrier',
              key: 'rejectKtpReason',
              value: null,
            })
          )
          dispatch(
            updateFormField({
              group: 'carrier',
              key: "rejectKtpMessage",
              value: null,
            })
          )
        } else if(returnAuditor){
          dispatch(
            updateFormField({
              group: 'carrier',
              key: "returnAuditorMessage",
              value: null,
            })
          )
        }
      }}
      handleConfirm={() => submit()}
      width={
        outcome === outcomes.returnAuditor
          ? 600
          : 400
      }
      cancelText={returnAuditor ? 'Άκυρο' : 'Ακύρωση'}
      okText={
        isBeneficiary(user?.groups)
        ? 'Υποβολή'
          : outcome === outcomes.returnAuditor
          ? 'Επιστροφή στον Ωφελούμενο'
          : 'Επιβεβαίωση'
      }
      submitDisabled={isBeneficiary(user?.groups) ?
                        false
                      : (isAuditor(user?.groups) && 
                        taskName === "task.name.application_evaluation_by_auditor" && 
                        outcome === "return" &&
                        isEmpty(returnAuditorMessage) || true) ? //temporarily true so to be disabled GBAST-463
                          true 
                        : false
                      }
      formKey={formKey}
      Icon={ (outcome === outcomes.auditReject)  ? WarningRed : WarningBlue }
      outcome={outcome}
      okButtonClassName={`custom-modal__submit-button ${submitDisabled ? 'is-disabled' : ''}`}
      user={user}
    >
      <div className="modal-submit-content">{renderContent()}</div>
    </Modal>
    </>
  );
};

export default SubmitModal;
